import type { KidStatusSummary } from "@/services/screen-budget/contracts";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface DevicesCardProps {
  kids: KidStatusSummary[];
  onUnenrollKid: (kidId: number) => Promise<void>;
  onRemoveKid: (kidId: number, kidName: string) => Promise<void>;
  isUnenrollingKid: boolean;
  isRemovingKid: boolean;
}

export function DevicesCard({
  kids,
  onUnenrollKid,
  onRemoveKid,
  isUnenrollingKid,
  isRemovingKid,
}: DevicesCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Devices</CardTitle>
        <CardDescription>Unenroll and remove devices for the selected family.</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-3">
        {kids.length === 0 ? (
          <p className="text-sm text-muted-foreground">No devices paired yet.</p>
        ) : (
          kids.map(kid => (
            <div key={kid.kidId} className="flex flex-wrap items-center justify-between gap-3 rounded-md border p-3">
              <div>
                <p className="font-medium">{kid.displayName}</p>
                <p className="text-xs text-muted-foreground">
                  Effective time: {Math.max(0, Math.round(kid.effectiveTimeLeftSeconds / 60))}m
                  {kid.outstandingMessageCount > 0 ? (
                    <> · Waiting for device to connect: {kid.outstandingMessageCount}</>
                  ) : null}
                </p>
              </div>
              <div className="flex items-center gap-2">
                <Button
                  type="button"
                  variant="outline"
                  disabled={kid.status === "UNENROLLED" || isUnenrollingKid || isRemovingKid}
                  onClick={() => void onUnenrollKid(kid.kidId)}
                >
                  {kid.status === "UNENROLLED" ? "Unenrolled" : "Unenroll"}
                </Button>
                {kid.status === "UNENROLLED" ? (
                  <Button
                    type="button"
                    variant="outline"
                    className="border-red-300 text-red-700 hover:bg-red-50"
                    disabled={isRemovingKid || isUnenrollingKid}
                    onClick={() => void onRemoveKid(kid.kidId, kid.displayName)}
                  >
                    Remove from family
                  </Button>
                ) : null}
              </div>
            </div>
          ))
        )}
      </CardContent>
    </Card>
  );
}
